import React, { Component } from "react";
import axios from "axios";
import TopNav from "../../components/common/TopNav";
import SideBar from "../../components/common/SideBar";

class SupportedPatient extends Component {
  constructor(props) {
    super(props);
    this.state = {
      patients: [],
      loading: true,
      error: null,
    };
  }

  componentDidMount() {
    axios
      .get("https://web2.mybiocalculus.com/api/patients/getSupporttedPerson")
      .then((res) => {
        // If response is an array of arrays, flatten it
        const data =
          Array.isArray(res.data) && Array.isArray(res.data[0])
            ? res.data[0]
            : res.data;
        this.setState({ patients: data, loading: false });
      })
      .catch((err) => {
        this.setState({ error: "Failed to fetch data", loading: false });
      });
  }

  renderTable = () => {
    const { patients } = this.state;
    const sortedPatients = patients.slice().sort((a, b) => {
      // Sort descending by supportDateTime (most recent first)
      const dateA = a.supportDateTime
        ? new Date(a.supportDateTime)
        : new Date(0);
      const dateB = b.supportDateTime
        ? new Date(b.supportDateTime)
        : new Date(0);
      return dateB - dateA;
    });
    return (
      <table className="table table-striped">
        <thead>
          <tr>
            <th>Patient ID</th>
            <th>Patient Name</th>
            <th>Customer Name</th>
            <th>Supported Person</th>
            <th>Support Comment</th>
            <th>Support Level</th>
            <th>Supported Date&Time</th>
            <th>Supported Date&Time</th>

            {/* <th>Support Level</th> */}
          </tr>
        </thead>
        <tbody>
          {sortedPatients.map((p) => {
            // Format supportDateTime to "Month Date, Year HH:mm:ss IST"
            let formattedDate = "NA";
            if (p.supportDateTime) {
              const date = new Date(p.supportDateTime);
              formattedDate = date.toLocaleString("en-IN", {
                timeZone: "Asia/Kolkata",
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false,
              });
            }
            // Map supportLevel to label
            let supportLevelLabel = "NA";
            switch (p.supportLevel) {
              case "L0":
                supportLevelLabel = "Frontline Support";
                break;
              case "L1":
                supportLevelLabel = "Tech Support";
                break;
              case "L2":
                supportLevelLabel = "Clinical Support";
                break;
              case "L3":
                supportLevelLabel = "Management Support";
                break;
              default:
                supportLevelLabel = p.supportLevel || "NA";
            }

            return (
              <tr key={p._id}>
                <td>{p.device_id}</td>
                <td>{p.name}</td>
                <td>{p.customerName}</td>
                <td>
                  {p.supportPersonDetails && p.supportPersonDetails.name
                    ? p.supportPersonDetails.name
                    : "NA"}
                </td>
                <td>{p.supportcomment}</td>
                <td style={{ textAlign: "left" }}>{supportLevelLabel}</td>
                <td style={{ textAlign: "center" }}>{formattedDate}</td>
                <td style={{ textAlign: "center" }}>{formattedDate}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  render() {
    const { loading, error } = this.state;
    // Use the same menus/profileLink logic as patient-list.js
      const menus = [
        { title: "Verifier Home", url: "/verifier-home" },
        { title: "Patient list", url: "/patient-list" },
        { title: "Labled Patients", url: "/labled-patients" },
        { title: "Verified", url: "/verification-completed" },
  
      ];
      if (localStorage.getItem("verifiertype") === "8") {
        menus.splice(2, 0, { title: "Patient-hold", url: "/patient-hold" });
      }
        if (localStorage.getItem("AdminUser") === "8") {
          menus.splice(3, 0, { title: "Device Deatils", url: "/device-details" });
          menus.splice(4, 0, { title: "Battery Issue", url: "/battery-issue" });
        }
  
      if (localStorage.getItem("verifiertype") === "8") {
        menus.splice(4, 0, { title: "Support Home", url: "/support-home" });
      }
      if (localStorage.getItem("verifiertype") === "8") {
        menus.splice(5, 0, { title: "QC Home", url: "/qc_home" });
      }
      if (localStorage.getItem("verifiertype") === "8") {
        menus.splice(6, 0, { title: "Support Web", url: "/support-homeweb" });
      }
      if (localStorage.getItem("AdminUser") === "8") {
        menus.splice(6, 0, { title: "Report Shared", url: "/report-shared" });
      }
      if (localStorage.getItem("AdminUser") === "8") {
        menus.splice(6, 0, {
          title: "Supported Person",
          url: "/supported-persons",
        });
       
        }
         if (localStorage.getItem("AdminUser") === "8") {
          menus.splice(6, 0, {
            title: "Reset Password",
            url: "/ResetPassword",
          });
      }
    const profileLink = "verifier-profile";
    return (
      <div className="wrapper theme-6-active box-layout pimary-color-green">
        <TopNav profileLink={profileLink} />
        <SideBar menus={menus} />
        <div className="right-sidebar-backdrop"></div>
        <div className="page-wrapper" style={{ marginTop: "30px" }}>
          <div className="container-fluid">
            <div className="panel panel-default card-view">
              <div className="panel-heading">
                <div className="pull-left">
                  <h6 className="panel-title txt-dark">Supported Patients</h6>
                </div>
                <div className="clearfix"></div>
              </div>
              <div className="panel-wrapper collapse in">
                <div className="panel-body">
                  {loading ? (
                    <div>Loading...</div>
                  ) : error ? (
                    <div style={{ color: "red" }}>{error}</div>
                  ) : (
                    this.renderTable()
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SupportedPatient;
